import { Injectable } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http } from '@angular/http';
import 'rxjs/add/operator/toPromise';

@Injectable()
export class TelecallerSlotMasterService {
    private headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' });
    private baseUrl = 'api/telecallerSlotMaster';

    constructor(private http: Http) { }

    private extractData(res: any) {
        let body = res.json();
        return body || [];
    }

    private handleError(error: any): Promise<any> {
        return Promise.reject(error.message || error);
    }

    getSlotList(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) { params.set(key.toString(), query[key]); }
        let options = new RequestOptions({ headers: this.headers, search: params });
        return this.http.get(`${this.baseUrl}/getSlotList`, options)
            .toPromise().then(this.extractData).catch(this.handleError);
    }

    addUpdateSlot(data: any): Promise<any> {
        return this.http.post(`${this.baseUrl}/addUpdateSlot`, $.param(data), { headers: this.headers })
            .toPromise().then(res => res.json() as any).catch(this.handleError);
    }

    deleteSlot(data: any): Promise<any> {
        return this.http.post(`${this.baseUrl}/deleteSlot`, $.param(data), { headers: this.headers })
            .toPromise().then(res => res.json() as any).catch(this.handleError);
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/services/telecallerSlotMaster.service.ts